export default "__VITE_ASSET__Csc6sWAV__"